import ReviewCard from '@/components/base/ReviewCard';
import { reviews } from '@/mocks/reviews';

export default function Reviews() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            客户口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            听听他们怎么说
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review) => (
            <ReviewCard
              key={review.id}
              name={review.name}
              rating={review.rating}
              content={review.content}
              date={review.date}
              product={review.product}
            />
          ))}
        </div>
      </div>
    </section>
  );
}